import script from "./NewOurServicesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewOurServicesPage.vue?vue&type=script&setup=true&lang=js"

import "./NewOurServicesPage.vue?vue&type=style&index=0&id=d889bf6e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d889bf6e"]])

export default __exports__